export default __webpack_public_path__ + "static/media/hyperspace-no-2.c7d7aeb5.ogg";